import { defineStore } from 'pinia'
import { Amplify } from 'aws-amplify'
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import awsconfig from '@/config/AuthConfig'

Amplify.configure(awsconfig)

export const userStore = defineStore({
  id: 'user',
  state: () => ({
    // user is retrieved from cognito
    user: null as {[key: string]: any} | null,
    // account is retrieved from the api
    account: null as {[key: string]: any} | null,
    userRefreshing: false as boolean,
  }),
  getters: {
    email: (state) => {
      return state.user?.signInDetails?.loginId
    },
    name: (state) => {
      return state.user?.signInDetails?.loginId
    },
    loggedIn: (state): boolean => {
      return state.user !== null && typeof(state.user) !== 'undefined'
    },
  },
  actions: {
    async refreshUser() {
      // https://docs.amplify.aws/vue/build-a-backend/auth/connect-your-frontend/manage-user-sessions/
      this.userRefreshing = true;
      try {
        this.user = await getCurrentUser();
      } catch (error) {
        // user is not logged in
        this.user = null;
      } finally {
        this.userRefreshing = false;
      }
    },
    async logOut() {
      await signOut();
      this.user = null;
      this.account = null;
    }
  },
})
